@if (navigationElement) {
  <div class="main advisor" [class.active]="navigationElement.isActive">
    <a (click)="showOverlay = !showOverlay" class="show-overlay">
      <span class="show-overlay" [innerHTML]="navigationElement.textPrefix + 'name' | translate"></span>
    </a>
    @if (showOverlay) {
      <div class="overlay">
        <p [innerHTML]="navigationElement.textPrefix + 'description' | translate"></p>
        @if (navigationElement.url) {
          <a class="button inline-arrow-right" [href]="navigationElement.url" [innerHTML]="navigationElement.textPrefix + 'button' | translate"></a>
        }
      </div>
    }
  </div>
}
